var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-disc-stop",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "779") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(8.525950, 0.709450) rotate(-45.000000) translate(-8.525950, -0.709450) ",
    x: 7.52595959,
    y: 0.209454795,
    width: 2.14597942,
    height: 1.22898821
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(1.249550, 9.343550) rotate(225.032412) translate(-1.249550, -9.343550) ",
    x: 0.749554715,
    y: 8.34355943,
    width: 1.22898841,
    height: 2.14597976
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.115,
    cy: 5.141,
    rx: 3.115,
    ry: 3.141
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.988,3.022 C3.892,3.022 3.009,3.908 3.009,4.999 C3.009,6.091 3.893,6.975 4.988,6.975 C6.079,6.975 6.967,6.091 6.967,4.999 C6.967,3.908 6.079,3.022 4.988,3.022 L4.988,3.022 Z",
    fill: "#434343",
    className: "si-glyph-fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.301,10.953 C15.701,9.962 15.958,8.986 15.958,7.969 C15.958,3.556 12.385,0.063 7.979,0.063 C3.573,0.063 0,3.556 0,7.969 C0,12.381 3.572,15.958 7.979,15.958 C8.659,15.958 9.311,15.858 9.938,15.694 L10.969,15.437 L10.938,10.953 L15.301,10.953 L15.301,10.953 Z M12.261,2.891 L13.13,3.76 L11.612,5.278 L10.743,4.409 L12.261,2.891 L12.261,2.891 Z M3.633,13.193 L2.765,12.324 L4.283,10.806 L5.151,11.675 L3.633,13.193 L3.633,13.193 Z M5,8.00095511 C5,6.34383954 6.3434992,5 8,5 C9.65553772,5 11,6.34288443 11,8.00095511 C11,9.65616046 9.65553772,11 8,11 C6.34253612,11 5,9.65711557 5,8.00095511 L5,8.00095511 Z",
    fill: "#434343",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#434343",
    x: 12,
    y: 12,
    width: 4.02331543,
    height: 4,
    className: "si-glyph-fill"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisc);
export default __webpack_public_path__ + "static/media/disc.9baa0bb2943a1f583d1b279482a1aa4f.svg";
export { ForwardRef as ReactComponent };